import { ErrorCode, InfoEventName, ReportErrorOptions, reportError, reportInfo } from '@ms/yammer-data/dist/telemetry';
import { getBrowserInfo } from '@ms/yammer-telemetry/dist/browser';
import { setLogLevel } from '@ms/yammer-telemetry/dist/logging';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';

import config from '../../config';

export const reportBootstrapStarted: VoidFunction = () => {
  reportInfo({
    eventName: InfoEventName.BootstrapStarted,
    eventProperties: {
      ...getBrowserInfo(),
      urlRootPath: getUrlRootPath(window.location.pathname),
    },
  });
};

export const reportErrorWithCode: (error: ReportErrorOptions['error'], errorCode: ErrorCode) => void = (
  error,
  errorCode
) => {
  reportError({ error, eventProperties: { errorCode } });
};

export const setupLogging: VoidFunction = () => {
  setLogLevel(config.logging.logLevel);
};
